import Storage from './Storage';
export default Storage;